import { isUuid } from '@notifi/uuid/validate';
import { createFileRoute } from '@tanstack/react-router';
import { ItemStockPage } from '@/features/inventory/ItemStockPage';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/items/$itemId')({
  /** `from`: the warehouse or truck the material was opened from. */
  validateSearch: (search: Record<string, unknown>): { from?: string } => ({
    from: isUuid(search.from) ? (search.from as string) : undefined,
  }),
  component: Page,
});
function Page() {
  const { itemId } = Route.useParams();
  const { from } = Route.useSearch();
  return <ItemStockPage key={itemId} itemId={itemId} from={from} />;
}
